import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"sandwich"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M14.2788 3.3934C14.6979 3.16478 15.2202 3.26433 15.5259 3.6311L20 8.99999V21H4V8.99999L14.2788 3.3934Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M20 9V15H4V9H20Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M4 15H20M4.75 9.00003H19.25M20 9.36208V21H4V9.00003L14.2788 3.3934C14.698 3.16478 15.2203 3.26433 15.5259 3.63111L19.7682 8.7219C19.918 8.90161 20 9.12815 20 9.36208Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const Sandwich = Vue.extend<IconProps>({
  name: 'SandwichIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'sandwich',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default Sandwich;
